<template>
  <div class="head">
   <van-row>
      <van-col span="3" class="back"><img @click.stop="goBack" class="img" src="@/assets/imgs/nav_icon_back.png" /></van-col>
      <van-col span="18">
        <div class="header">{{title}}</div>
      </van-col>
      <van-col span="3"></van-col>
    </van-row>
  </div>
  
</template>
<script>
export default {
  name: "Header",
  props: {
    title: String
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="stylus" scoped>
// .head {
//   position: fixed;
//   top: 0;
//   left: 0;
//   height: 88px;
// }
.head >>> .van-row {
   line-height: 88px;
}
.back {
  padding-left: 20px;
}
img {
  vertical-align: middle;
  width 24.83px
  height 45.66px
  line-height: 88px;
}
.header {
  line-height: 88px;
  text-align: center;
  font-weight: bold;
  color: #000;
  font-size:32px;
  display: inline-block;
  white-space: nowrap; 
  width: 100%; 
  overflow: hidden;
  text-overflow:ellipsis;
}
</style>